export interface DataEntity_Detail_01_Interface {
    id:number,
    main_id:number,
    reference_Value_Position_Max:number,
    reference_Value_Position_Min:number,
}

export function Empty_DataEntity_Detail_01_Interface():DataEntity_Detail_01_Interface{
    return{
        id:0,
        main_id:0,
        reference_Value_Position_Max:0,
        reference_Value_Position_Min:0,
    }
  }